import { isDevFeatureEnabled } from './devFeatureFlags';
import { LocalFeatureFlags, OpenFeatureFlags, RemoteFeatureFlags } from './featureFlags';
import { useRemoteFeatureFlag } from './useRemoteFeatureFlag';

export function useFeatureFlag(feature: OpenFeatureFlags) {
  const [remoteFeature] = useRemoteFeatureFlag(feature as RemoteFeatureFlags);
  const localFeature = isDevFeatureEnabled(feature as LocalFeatureFlags);

  return [remoteFeature || localFeature];
}
